<template>
    <div>
    <p class="market-title">
      <img src="/static/images/icons/marketplace_icon_blue.svg" class="marketplace-icon" />
      <span>Marketplace</span>
    </p>
      <div class="col-md-12 col-xs-12 col-sm-12">
        <div
          class="col-md-12 col-xs-12 col-sm-12 market-content"
          v-for="(service,index) in topTwoServices"
          :key="index"
        >
          <div class="row market-img">
              <div class="pt-4">
                <img
                  :src="getBlobUrl(service.icon_location)"
                  alt="service-icon"
                />
              </div>
            <div class="col-xs-12">
              <div class="mt-5 pl-5">
                <span @click="learnMore(service.id)" class="product-service cursor-pointer">
                  <span>{{service.name}}</span>
                </span>
                <p class="product-content">{{service.description}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { sortBy } from 'lodash';
import EventBus from '../../../../utils/event-bus';
import { getServiceDesc } from '../../../../apis/marketPlace';

export default {
  data() {
    return {
      topTwoServices: [],
      services: [],
      loaderStatus: false,
    };
  },
  methods: {
    async getServiceDesc() {
      this.services = await getServiceDesc();
      this.services = sortBy(this.services, 'sequence');
      const services = this.services.filter((service) => service.id !== 5 && service.id !== 8);
      this.topTwoServices = services.slice(0, 2);
    },
    learnMore(id) {
      EventBus.$emit('activeMenuTitle', this.$route.meta.title);
      this.$router.push({ path: `/layout/market-place/service/${id}` });
    },
    getBlobUrl(filePath, tokenRequired) {
      if (filePath) {
        if (tokenRequired) {
          return `${process.env.VUE_APP_AZURE_BLOB_URL}${filePath}${this.sasToken}`;
        }
        return `${process.env.VUE_APP_AZURE_BLOB_URL}${filePath}`;
      }
      return null;
    },
  },
  async created() {
    try {
      this.loaderStatus = true;
      await this.getServiceDesc();
      this.loaderStatus = false;
    } catch (err) {
      this.loaderStatus = false;
    }
  },
};
</script>

<style scoped>
.market-title {
  display: flex;
  align-items: center;
  font-family: Roboto;
  font-weight: 500;
  font-style: normal;
  font-size: 22px;
  line-height: 26px;
  color: #0b3c61;
  padding-top: 24px;
  padding-left: 24px;
}
.market-title span {
  padding-left: 16px;
}
.marketplace-icon {
  width: 32px;
  height: 32px;
  margin-right: 0px;
}
.market-place-line {
  padding: 0px 20px 0px 15px;
}
.content-decoration {
  position: relative;
  padding: 0;
  border-top: 1px solid #174c76;
}
.headline-circle {
  position: absolute;
  border-radius: 50%;
  width: 5px;
  height: 5px;
  background: #174c76;
  padding: 0;
  right: 0;
  top: -3px;
}
.market-content {
  margin: 0;
  margin-top: 10px;
}
.market-img {
  display: inline-flex;
  margin-top: 7px;
  padding-left: 11px;

}
.market-img .pt-4 {
  padding-top: 4px;
}
.market-img img {
  width: 26px;
  height: 26px;
}
.mt-5 {
  margin-top: 5px;
}
.product-service {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 23px;
  color: #0B3C61;
  cursor: pointer;
}
.product-content {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.7);
  margin-top: 12px;
  margin-bottom: 0px;
}

.pr-0 {
  padding-right: 0px !important;
}
@media only screen and (max-width: 767px) {
  .market-content {
    margin-top: 12px;
  }
}
@media (min-width: 992px) and (max-width: 1200px) {
  .market-content {
    margin-top: 17px;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .market-content {
    margin-top: 15px;
  }
}

</style>
